export default __webpack_public_path__ + "static/media/logo-morada.1f7566e2.png";